import gql from 'graphql-tag';

export const LIST_EVENTS_QUERY = gql`
  query ListEvents(
    $first: Int
    $last: Int
    $after: Cursor
    $before: Cursor
    $query: String
  ) {
    events(
      first: $first
      last: $last
      after: $after
      before: $before
      query: $query
    ) @connection(key: "events") {
      edges {
        node {
          id
          name
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;
